export default __webpack_public_path__ + "static/media/olab-lab.99582e1c.png";